import http from './utils';
import { prefix, mockPrefix } from './constants';

export const createShortUrl: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/short/url/create`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};
 

const getShortUrlInfo: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/short/url/get`,
    method: 'post',
    data: payload,
  }) as Promise<any>;
};

export function getShortUrlParse(id: string) {
  if (!id) return {};

  return getShortUrlInfo({ short_url: id })
    .then((data: any) => {
      if (data) {
        return JSON.parse(data);
      }
      return {};
    })
    .catch(() => {
      return {};
    });
}



export const getFilterCond: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/filter/cond`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};

/**
 * 获取筛选器列表
 * @param payload 请求参数
 */
export const getFilterList: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/filter`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 删除筛选器
 * @param payload 请求参数
 */
export const deleteFilter: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/filter/delete`,
    method: 'post',
    ...payload,
  }) as Promise<any>;
};

/**
 * 添加筛选器
 * @param payload 请求参数
 */
export const addFilter: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/filter/add`,
    method: 'post',
    data: payload, 
  }) as Promise<any>;
};

/**
 * 检查筛选器名称
 * @param payload 请求参数
 */
export const checkFilterName: (payload: any) => Promise<any> | any = payload => {
  return http({
    url: `${prefix}/filter/check`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<any>;
};